export const WASTAGE_SAVE = "WASTAGE_SAVE";
export const WASTAGE_SAVE_SUCCESS = "WASTAGE_SAVE_SUCCESS";
export const WASTAGE_SAVE_FAIL = "WASTAGE_SAVE_FAIL";

export const WASTAGE_FILTER = "WASTAGE_FILTER";
export const WASTAGE_FILTER_SUCCESS = "WASTAGE_FILTER_SUCCESS";
export const WASTAGE_FILTER_FAIL = "WASTAGE_FILTER_FAIL";

export const WASTAGE_SINGLE_GET = "WASTAGE_SINGLE_GET";
export const WASTAGE_SINGLE_GET_SUCCESS = "WASTAGE_SINGLE_GET_SUCCESS";

export const WASTAGE_UPDATE = "WASTAGE_UPDATE";
export const WASTAGE_UPDATE_SUCCESS = "WASTAGE_UPDATE_SUCCESS";
export const WASTAGE_UPDATE_FAIL = "WASTAGE_UPDATE_FAIL";   // ✅ ADD

export const WASTAGE_DELETE = "WASTAGE_DELETE";
export const WASTAGE_DELETE_SUCCESS = "WASTAGE_DELETE_SUCCESS";
export const WASTAGE_DELETE_FAIL = "WASTAGE_DELETE_FAIL";   // ✅ ADD

export const WASTAGE_EXCEL_REPORT = "WASTAGE_EXCEL_REPORT";
export const WASTAGE_EXCEL_REPORT_SUCCESS = "WASTAGE_EXCEL_REPORT_SUCCESS";
export const WASTAGE_EXCEL_REPORT_FAIL = "WASTAGE_EXCEL_REPORT_FAIL";